module.exports = __webpack_public_path__ + "static/media/icon_user_SVIP.35feed4d.png";